import { Component } from '@angular/core';
import { JeevesCustomerDetailsComponent } from 'gung-standard-jeeves';
import { first } from 'rxjs';

@Component({
    selector: 'car-liner-customer-details',
    templateUrl: './car-liner-customer-details.component.html',
    styleUrls: ['./car-liner-customer-details.component.scss'],
    standalone: false
})
export class CarLinerCustomerDetailsComponent extends JeevesCustomerDetailsComponent {
  isSalesOrAdmin: boolean = false;

  ngOnInit(): void {
    super.ngOnInit();
    this.authService.getRoles().pipe(first()).subscribe(roles => {
      this.isSalesOrAdmin = roles.findIndex(r => r === 'ADMIN') > -1 || roles.findIndex(r => r === 'SALES') > -1;
    });
  }
}
